import React, { useEffect, Component } from "react";
import WithConsumer from '../../context/WithConsumer';

const Cover = ({ context }) => {
	
	const ctxSiteLoaded 	= () => context.siteLoaded;
	const siteLoaded 		= ctxSiteLoaded();
	
	const ctxCoverShown 	= () => context.coverShown;
	const coverShown 		= ctxCoverShown();
	
	const ctxGlobal 	= () => context.global;
	const global 		= ctxGlobal();
	
	const posts = () => context.posts;
    const post = posts()[0];
    
	let characters 		= 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
	let wait 			= 35;
	let rawTopArray 	= false;
	let rawBottomArray 	= false;
	let textCharCount 	= false;
	let charWidths 		= [];
	let aniInterval 	= null;
	let called 			= false;
	let frame 			= 0;
	let done 			= false;
	let charMaxLoop 	= 4;
	let textHTML 		= '';
	let brDone 			= false;
	
	function generateString() {
					
		let charCount 	= 0;
		let allDone 	= true;
		let randFound 	= false;
		let style 		= '';
		
		brDone 		= false;
		textHTML 		= '';
		
		for (let i=0;i<textCharCount;i++) {
			if ((i * charMaxLoop) < frame) {
				if (i < rawTopArray.length) {
					textHTML = textHTML + '<span>' + rawTopArray[i] + '</span>';
				} else {
					if (brDone === false) {
						textHTML = textHTML + '<br />';
						brDone = true;
					}
					textHTML = textHTML + '<span>' + rawBottomArray[(i - rawTopArray.length)] + '</span>';
				}
			} else {
				if (i < rawTopArray.length) {
					textHTML = textHTML + '<span style="width:' + charWidths[i] + 'px;' + style + '">' + generateRandString(1) + '</span>';
				} else {
					if (brDone === false) {
						textHTML = textHTML + '<br />';
						brDone = true;
					}
					textHTML = textHTML + '<span style="width:' + charWidths[(i - rawTopArray.length)] + 'px;' + style + '">' + generateRandString(1) + '</span>';
				}
				if (randFound === false) {
					style = 'opacity:0;';
					randFound = true;
				}
			}
			
		}
		
		frame = frame + 1;
		document.getElementsByClassName('c-cover__text')[0].innerHTML = textHTML;
		if (frame > ((rawTopArray.length + rawBottomArray.length) * charMaxLoop)) {
			clearInterval(aniInterval);
			setTimeout(() => {
				document.getElementsByClassName('c-cover')[0].classList.add('state-show-logo');
			}, 500);
		}
	}
	
	function generateRandString(length) {
	    let result = ' ';
	    const charactersLength = characters.length;
	    for ( let i = 0; i < length; i++ ) {
	        result += characters.charAt(Math.floor(Math.random() * charactersLength));
	    }
	    return result;
	}
	
				
	useEffect(() => {
		
		setTimeout(() => {
			if (coverShown === true && textCharCount && charWidths && document.getElementsByClassName('c-cover__text').length > 0) {
				for (let i=0;i<textCharCount;i++) {
					charWidths[i] = document.getElementsByClassName('c-cover__text')[0].getElementsByTagName('span')[i].clientWidth;	
				}
				if (coverShown === true) {
					aniInterval = setInterval(() => {
						generateString();
					}, wait);
					return () => clearInterval(aniInterval);
				}
			}
		}, 100);
	});
				
	if (context.global && post) {
		
		if (global.json === null) {
			context.getGlobal(window.location.origin + '/wp-json/castran/v1/global');
		}
				
		if (global.json !== null) { 
		
			if (global.json.cover_cinemagraph && global.json.cover_top_text && global.json.cover_bottom_text) {
				
				rawTopArray 	= global.json.cover_top_text.split('');
				rawBottomArray 	= global.json.cover_bottom_text.split('');
				textCharCount 	= rawTopArray.length + rawBottomArray.length;
								
				for (let i=0;i<textCharCount;i++) {
					if (i < rawTopArray.length) {
						textHTML = textHTML + '<span style="opacity:0">' + rawTopArray[i] + '</span>';
					} else {
						if (brDone === false) {
							textHTML = textHTML + '<br />';
							brDone = true;
						}
						textHTML = textHTML + '<span style="opacity:0">' + rawBottomArray[(i - rawTopArray.length)] + '</span>';
					}
				}
				
				
								
				return (
					<div className="c-cover">
						
						<video className="c-cover__video" src={global.json.cover_cinemagraph} autoPlay loop muted playsInline onTimeUpdate={function(){document.getElementsByClassName('c-video-splash__first-frame')[0].style.display = 'none';}}></video>
						
						{global.json.cover_image &&
							<img className="c-video-splash__first-frame" src={global.json.cover_image} alt="" />
						}
																
						
							
						<p className="c-cover__text" dangerouslySetInnerHTML={{__html:textHTML}}></p>
						
						<div className="c-cover__logo">
							<div className="c-cover__logo__inner" dangerouslySetInnerHTML={{__html:'<svg viewBox="0 0 212 31"><path d="m23.82 18.31-1.26 1.56c-1.56 1.89-3.89 2.98-6.34 2.94-4.35 0-7.9-3.26-7.9-7.27s3.54-7.27 7.9-7.27c2.45-0.04 4.79 1.04 6.34 2.94l1.26 1.56 6.59-4.69-1.35-1.67c-3.18-3.8-7.89-5.99-12.84-5.96-8.9 0-16.13 6.77-16.13 15.09s7.24 15.09 16.13 15.09c4.96 0.04 9.67-2.15 12.84-5.97l1.34-1.66-6.58-4.69zm64.97-8.77h8.86v21.09h8.33v-21.09h8.86v-8.33h-26.05v8.33zm-3.63 6.66c-0.87-1.06-1.94-1.94-3.14-2.59-1.15-0.61-2.37-1.07-3.63-1.36-1.21-0.28-2.23-0.49-3.01-0.61-0.18-0.03-0.36-0.06-0.55-0.08-0.16-0.02-0.31-0.05-0.46-0.11-0.74-0.15-1.46-0.37-2.16-0.67-0.74-0.32-0.85-0.71-0.86-0.95v-0.14c0-0.34 0-1.36 2.61-1.52 0.99-0.05 1.98 0.03 2.95 0.25 1.23 0.28 2.39 0.8 3.42 1.54l0.32 0.22 5.21-6.14-0.39-0.27c-1.08-0.75-2.24-1.39-3.45-1.9-1.98-0.84-4.1-1.33-6.25-1.45-0.92-0.05-1.71-0.05-2.38-0.02-1.65 0.08-3.28 0.45-4.8 1.11-1.23 0.54-2.35 1.3-3.3 2.25-0.83 0.85-1.47 1.87-1.88 2.99-0.38 1.04-0.57 2.14-0.54 3.25 0.05 2.24 1.03 4.36 2.69 5.85 1.98 1.72 4.42 2.84 7.02 3.23 0.23 0.07 0.46 0.12 0.7 0.13 0.2 0.02 0.39 0.06 0.58 0.11 1 0.15 1.81 0.3 2.41 0.46 0.46 0.1 0.91 0.26 1.34 0.45 0.21 0.09 0.4 0.23 0.55 0.41 0.08 0.11 0.13 0.25 0.13 0.39-0.01 0.11-0.03 0.23-0.06 0.33-0.07 0.17-0.18 0.31-0.32 0.43-0.72 0.71-2.01 1.04-3.83 0.94-0.44-0.01-0.88-0.06-1.32-0.15-0.53-0.11-1.06-0.28-1.56-0.49-0.57-0.24-1.12-0.54-1.64-0.89-0.57-0.39-1.09-0.84-1.56-1.35l-0.34-0.37-5.22 6.37 0.3 0.28c1.62 1.5 3.53 2.64 5.62 3.36 1.79 0.64 3.66 1 5.55 1.07h0.41c1.14 0.01 2.28-0.09 3.41-0.31 0.92-0.18 1.83-0.45 2.71-0.79 1.32-0.52 2.52-1.29 3.53-2.27 0.93-0.87 1.67-1.93 2.17-3.1 0.48-1.13 0.69-2.35 0.62-3.57-0.08-1.56-0.64-3.08-1.6-4.32zm118.43-14.99v16.12l-11.47-16.13h-9.11v29.42h8.33v-16.07l11.47 16.08h9.12v-29.42h-8.34zm-35.78 0.59h-7.78l-11.5 28.43-0.16 0.4h8.39l1.77-4.41h10.75l1.81 4.41h8.34l-11.55-28.65-0.07-0.18zm-6.13 16.67 2.21-5.52 2.26 5.52h-4.47zm-120.3-16.68-11.67 28.84h8.39l1.76-4.41h10.75l1.81 4.41h8.34l-11.59-28.84h-7.79zm1.66 16.68 2.21-5.52 2.25 5.52h-4.46zm100.63-14.43c-1.75-1.77-4.15-2.77-6.64-2.77h-19.18v29.29h8.29v-10.54h5.55l4.92 10.54h8.83l-5.18-11.12c0.14-0.05 0.28-0.11 0.42-0.17 1.11-0.47 2.12-1.15 2.98-2v0.01c0.85-0.86 1.53-1.87 2-2.98 0.49-1.15 0.74-2.4 0.74-3.65 0.01-1.25-0.25-2.49-0.74-3.63-0.47-1.11-1.15-2.12-1.99-2.98zm-5.93 7.48c-0.23 0.24-0.54 0.37-0.87 0.36h-10.73v-2.47h10.73c0.33-0.01 0.65 0.12 0.87 0.37 0.23 0.22 0.36 0.52 0.36 0.84 0.02 0.34-0.11 0.66-0.36 0.9z" fill="#3C3C3C"/></svg>'}}>
							</div>
						</div>
												
					</div>
				)
			
			} else {
			
				return null;
			
			}
			
		} else {
			
			return null;
			
		}
		
	} else {
			
		return null;
		
	}
	
}
export default WithConsumer(Cover);